import { Box, Divider } from '@mui/material';
import { Button, Checkbox, Typography } from '@sm-dashboard/ui-components';
import { useEffect, useState } from 'react';
import { useAppContext } from '@/context/context';

interface FeedTagsAllowProps {
  onClose?: () => void;
  existingTags?: string[];
  onSave: (selectedTags: string[]) => Promise<void>;
}

const FeedTagsAllow = ({ onClose, existingTags, onSave }: FeedTagsAllowProps) => {
  const [selectedTagsState, setSelectedTags] = useState<string[]>(existingTags || []);
  const [saving, setSaving] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { setSnackbar, tags } = useAppContext();

  useEffect(() => {
    if (existingTags) {
      setSelectedTags(existingTags);
    }
  }, [existingTags]);

  const handleTagToggle = (tag: string) => {
    setSelectedTags(prev => {
      if (prev.includes(tag)) {
        return prev.filter(t => t !== tag);
      } else {
        return [...prev, tag];
      }
    });
  };

  const handleSavePermissions = async () => {
    try {
      setSaving(true);
      await onSave(selectedTagsState);
      if (onClose) {
        onClose();
        setSnackbar({
          message: 'הרשאות הפוסט עודכנו בהצלחה',
          severity: 'success',
          open: true
        });
      }
    } catch (error) {
      console.error('שגיאה בשמירת הרשאות:', error);
      setError('אירעה שגיאה בשמירת הרשאות הפוסט');
      setSnackbar({
        message: 'אירעה שגיאה בשמירת הרשאות הפוסט',
        severity: 'error',
        open: true
      });
    } finally {
      setSaving(false);
    }
  };

  if (error)
    return (
      <Typography variant="body" color="text.secondary">
        {error}
      </Typography>
    );

  return (
    <Box sx={{ minHeight: '200px' }}>
      <Divider sx={{ width: '100%', mb: 2 }} />
      {tags && tags.length > 0 ? (
        <>
          <Box sx={{ maxHeight: '300px', overflow: 'auto' }}>
            {tags.map(item => (
              <Box
                key={item.tag}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: 1,
                  mt: 1,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)'
                  },
                  padding: '8px'
                }}
              >
                <Checkbox
                  checked={selectedTagsState.includes(item.tag)}
                  onChange={() => handleTagToggle(item.tag)}
                  label={item.tag}
                />
              </Box>
            ))}
          </Box>
        </>
      ) : (
        <Typography variant="body" color="text.secondary">
          אין תגיות זמינות
        </Typography>
      )}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mt: 2,
          pt: 2
        }}
      >
        <Button variant="outlined" onClick={onClose} disabled={saving}>
          ביטול
        </Button>
        <Button onClick={handleSavePermissions} loading={saving}>
          שמירת הרשאות
        </Button>
      </Box>
    </Box>
  );
};

export default FeedTagsAllow;
